
    module.exports = {
      render: function(){with(this){return _c('div')}},
      staticRenderFns: []
    };
  


//////////////////
// WEBPACK FOOTER
// ./src/view/example.html
// module id = 191
// module chunks = 0